import { useState } from 'react';
import BrokerAdminPage from './features/broker-admin/BrokerAdminPage';
import MqttMessagesPage from './features/mqtt/MqttMessagesPage';
import './App.css';

function getInitialPage() {
  return window.location.hash === '#device-access' ? 'device-access' : 'messages';
}

export default function App() {
  const [page, setPage] = useState(getInitialPage);

  function navigate(nextPage) {
    setPage(nextPage);
    window.location.hash = nextPage === 'device-access' ? 'device-access' : '';
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-brand">
          <span className="app-brand-mark">TPN</span>
          <div>
            <strong>Telemetry control</strong>
            <span>MQTT Monitor</span>
          </div>
        </div>
        <nav className="app-nav" aria-label="Primary navigation">
          <button
            type="button"
            className={page === 'messages' ? 'active' : ''}
            onClick={() => navigate('messages')}
          >
            Live messages
          </button>
          <button
            type="button"
            className={page === 'device-access' ? 'active' : ''}
            onClick={() => navigate('device-access')}
          >
            Device access
          </button>
        </nav>
      </header>

      <main>
        {page === 'device-access' ? <BrokerAdminPage /> : <MqttMessagesPage />}
      </main>
    </div>
  );
}
